import type { AppDefinition } from '@klp/core/app/classes/AppDefinition';
import { Block, Tooltip } from '@klp/design';
import { IconName, Illustration } from '@klp/design/Illustrations';
import { useKlpStyles } from '@klp/design/Theme/useKlpStyles';
import {
    ClickAwayListener,
    Hidden,
    IconButton,
    MenuItem,
    Select,
} from '@material-ui/core';
import React from 'react';

const styles = () => ({
    appSelector: {
        width: 0,
        height: 0,
        '& > div': {
            width: 0,
            height: 0,
            padding: 0,
            minWwidth: 0,
            minHeight: 0,
        },
        '& > svg': {
            display: 'none',
        },
    },
});

type HeaderToolbarAppSelectorProps = {
    appSelection: Array<AppDefinition>;
};
export const HeaderToolbarAppSelector: React.FC<
    HeaderToolbarAppSelectorProps
> = ({ appSelection }) => {
    const [showAppSelector, setShowAppSelector] = React.useState(false);

    const classes = useKlpStyles({}, styles);

    const handleAppSelect = (event: React.ChangeEvent<HTMLInputElement>) => {
        setShowAppSelector(false);
        const entry: AppDefinition = appSelection[event.target.value];
        if (entry.openInNewTab) {
            window.open(entry.url, '_blank');
        } else {
            window.location.href = entry.url;
        }
    };

    return (
        <>
            {appSelection.length > 1 && (
                <Hidden xsDown={true}>
                    <ClickAwayListener
                        onClickAway={() => setShowAppSelector(false)}
                        disableReactTree={true}
                    >
                        <Block>
                            <Tooltip translation="general.links" title="">
                                <IconButton
                                    onClick={() => setShowAppSelector(true)}
                                    color="secondary"
                                >
                                    <Illustration
                                        icon={IconName.CHANGE}
                                        klpColor="main"
                                    />
                                </IconButton>
                            </Tooltip>
                            <Select
                                onChange={handleAppSelect}
                                disableUnderline={true}
                                open={showAppSelector}
                                className={classes.appSelector}
                                value={0}
                            >
                                {appSelection.map(({ name }, index) => (
                                    <MenuItem key={index} value={index}>
                                        {name}
                                    </MenuItem>
                                ))}
                            </Select>
                        </Block>
                    </ClickAwayListener>
                </Hidden>
            )}
        </>
    );
};
